import { CmsProtectionDetailsUpsellModal } from '../../models/protection-details/cms-protection-details-upsell-modal.interface';

export const mockCmsProtectionDetailsUpsellModal: CmsProtectionDetailsUpsellModal =
  {
    protectionDetailsModalBenefitsListItems: [
      { item: 'Immediate coverage for accidental damage​' },
      { item: 'Unlimited repairs with no surprise fees​' },
      {
        item: "If we can't fix it, we'll replace it with a like-for-like model​",
      },
    ],
    protectionDetailsModalBenefitsListTitle:
      'protectionDetailsModalBenefitsListTitle',
    protectionDetailsModalSubtitle: 'protectionDetailsModalSubtitle',
    protectionDetailsModalTitle: 'protectionDetailsModalTitle',
  };
